"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GlobeFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GlobeFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.252 6A8.014 8.014 0 0 0 0 8c0 .69.088 1.36.252 2h4.361a17.332 17.332 0 0 1 .003-4H.252ZM.582 5h4.183C5.29 2.112 6.54 0 8 0c1.46 0 2.71 2.112 3.235 5h4.184A8.003 8.003 0 0 0 .582 5ZM15.748 6h-4.364a17.375 17.375 0 0 1 .002 4h4.362c.165-.64.252-1.31.252-2s-.088-1.36-.252-2ZM15.418 11h-4.18c-.523 2.891-1.776 5-3.238 5s-2.715-2.109-3.239-5H.581a8.003 8.003 0 0 0 14.838 0ZM10.5 8.01c0 .69-.043 1.357-.12 1.99H5.62c-.078-.633-.12-1.3-.12-1.99 0-.695.043-1.37.123-2.01h4.754c.08.64.123 1.315.123 2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.442 13.222c-.272-.628-.5-1.382-.663-2.222h4.442a10.84 10.84 0 0 1-.663 2.222c-.285.656-.6 1.129-.898 1.423-.295.29-.517.355-.66.355-.143 0-.365-.065-.66-.355-.299-.294-.613-.767-.898-1.423ZM5.782 5c.163-.835.39-1.586.661-2.212.285-.66.6-1.135.898-1.431C7.637 1.064 7.86 1 8 1c.141 0 .363.064.659.357.299.296.613.772.898 1.431.27.626.498 1.377.66 2.212H5.783Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GlobeFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GlobeFill;
exports["default"] = _default;